import actions from "./actions";
import state from "./states";
import mutations from "./mutations";

const AdminMerchantModule = {
  namespaced: true,
  actions,
  state,
  mutations,
};

export default AdminMerchantModule;